import {Handler} from "./Handler";

export class PathHandler extends Handler {

	/**
	 * @param {EdgeEditor} parent parent editor
	 * @param {PConCoords} coords
	 * @param {number} mpIdx middle point index
	 */
	constructor(parent, coords, mpIdx) {
		super(parent);
		this.coords = coords;
		this.idx = mpIdx;
	}


	get x() {
		return this.coords.mp[this.idx].x;
	}

	get y() {
		return this.coords.mp[this.idx].y;
	}

	set x(val) {
		this.coords.mp[this.idx].x = val;
	}

	set y(val) {
		this.coords.mp[this.idx].y = val;
	}
}